<template>
  <router-view></router-view>
</template>

<script>
export default {
  name:  'exhibition-control-brandInt',
  data() {
    return {
    }
  },
  created() {
    document.title = "中国国际医疗器械博览会 - 旗下品牌";
  }
}
</script>

<style scoped lang="scss">
</style>
